<template>
  <div class="building-status-editor">
    <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-6 mb-2">
        <div class="label">วันเริ่มต้น</div>
        <date-picker
          class="w-100"
          v-model="value.startAt"
          :disabled="disabled"
        ></date-picker>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6 mb-2">
        <div class="label">วันสิ้นสุด</div>
        <date-picker
          class="w-100"
          v-model="value.endAt"
          :disabled="disabled"
        ></date-picker>
      </div>
    </div>
    <div class="mb-3">
      <div class="label">สถานะ</div>
      <el-select v-model="value.status" :disabled="disabled">
        <el-option
          v-for="status in instructionStatus"
          :label="status.label"
          :value="status.value"
          :key="status.value"
        ></el-option>
      </el-select>
    </div>
    <hr />
    <div class="detail-list">
      <div class="label">
        <strong>รายการงาน</strong>
      </div>
      <template v-for="(task, index) in value.tasks">
        <instruction-task
          class="mb-3"
          v-model="value.tasks[index]"
          :disabled="disabled"
          @remove="handleClickRemoveTaskButton(index)"
        ></instruction-task>
      </template>
      <sc-button
        class="w-100 mt-4"
        size="sm"
        @click="handleClickAddTaskButton"
        v-if="!disabled"
        >เพิ่มงาน</sc-button
      >
    </div>
    <hr />
    <div class="mb-3">
      <div class="label">ความคืบหน้าโดยรวม (%)</div>
      <el-input v-model="value.overallProgress" :disabled="disabled"></el-input>
    </div>
    <div class="mb-3">
      <div class="label">อัพเดทล่าสุดเมื่อ</div>
      <date-picker
        class="w-100"
        v-model="value.updatedAt"
        :disabled="disabled"
      ></date-picker>
    </div>
    <div class="mb-3">
      <div class="label">รูปการก่อสร้าง</div>
      <album-picker
        v-model="value.imageFiles"
        :disabled="disabled"
        :imageUrls="imageUrls"
        :maxNumberOfImages="5"
        @removeImage="handleClickRemoveImageButton"
      ></album-picker>
    </div>
  </div>
</template>

<script>
import { Select, Option, Input } from "element-ui";
import DatePicker from "@/lib/components/DatePicker";
import InstructionTask from "./InstructionTask";
import AlbumPicker from "./AlbumPicker";
import ScButton from "@/lib/components/ScButton";

export default {
  components: {
    DatePicker,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    InstructionTask,
    ScButton,
    AlbumPicker
  },
  props: ["value", "imageUrls", "disabled"],
  data() {
    const instructionStatus = [
      { value: "START", label: "เริ่มต้น" },
      { value: "INPROGRESS", label: "กำลังก่อสร้าง" },
      { value: "COMPLETED", label: "เสร็จสิ้น" }
    ];

    return {
      date: null,
      instructionStatus
    };
  },
  methods: {
    handleClickAddTaskButton() {
      this.$emit("input", {
        ...this.value,
        tasks: [...this.value.tasks, { name: "", progress: 0, startAt: null }]
      });
    },
    handleClickRemoveTaskButton(index) {
      this.$emit("input", {
        ...this.value,
        tasks: this.value.tasks.filter((t, i) => i !== index)
      });
    },
    handleClickRemoveImageButton(index) {
      this.$emit("removeImage", index);
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/projects/components/BuildingStatusEditor.vue